module.exports = __webpack_public_path__ + "img/logo-login.82b9c7a5.png";